// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"3079ca94","76":"48e151df","262":"fbd6b350","296":"1094caad","355":"02b151e3","378":"2c89382d","406":"854a9336","581":"60041eb9","601":"82dcc196","732":"e28105e1","744":"923b43d5","814":"e1eda614","984":"33073784"}[chunkId] + ".chunk.js";
};